import { Tooltip } from "@material-ui/core";
import React from "react";

const ToolTipWrap = (props) => {
  const { title, children, postion } = props;
  return <Tooltip title={title}>{children}</Tooltip>;
};

export default ToolTipWrap;
